__webpack_require__.S = {};
const initPromises = {};
const initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	let initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	const scope = __webpack_require__.S[name];
	const warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	const uniqueName = "@wutomi/mgmt-module-settings-users";
	const register = (name, version, factory, eager) => {
		const versions = scope[name] = scope[name] || {};
		const activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	const initExternal = (id) => {
		const handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			const module = __webpack_require__(id);
			if(!module) return;
			const initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			const initResult = initFn(module);
			if(initResult?.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	const promises = [];
	switch(name) {
		case "default": {
			register("react-dom", "19.2.8", () => (Promise.all([__webpack_require__.e(911), __webpack_require__.e(144)]).then(() => (() => (__webpack_require__(144))))));
			register("react-router-dom", "7.18.2", () => (Promise.all([__webpack_require__.e(398), __webpack_require__.e(911), __webpack_require__.e(233)]).then(() => (() => (__webpack_require__(398))))));
			register("react", "19.2.8", () => (__webpack_require__.e(41).then(() => (() => (__webpack_require__(41))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};